import React from 'react';
interface ButtonProps {
  variant?: 'primary' | 'secondary-light' | 'secondary-dark';
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: '_blank' | '_top' | '_self';
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  href = 'https://wa.me/40771296017',
  target = '_top'
}: ButtonProps) {
  const baseClasses = 'px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors inline-flex items-center justify-center text-center';
  const variants = {
    primary: 'bg-rise-gold text-rise-black hover:bg-rise-gold-light',
    'secondary-light': 'border border-rise-black text-rise-black hover:bg-rise-black hover:text-rise-white',
    'secondary-dark': 'border border-rise-gold text-rise-gold hover:bg-rise-gold/10'
  };
  const isExternal = target === '_blank';
  return <a href={href} target={target} rel={isExternal ? 'noopener noreferrer' : undefined} className={`${baseClasses} ${variants[variant]} ${className}`} data-id="element-112" data-mp="30sjsc7ozivpz">
      {children}
    </a>;
}